export const PURPOSE_OF_STAY_TYPES = {
  UNDERGRADUATE: 'undergraduate',
  POSTGRADUATE: 'postgraduate',
  SUMMER_SCHOOL: 'summer-school',
  INTERNSHIP: 'internship',
  PROFESSIONAL_PLACEMENT: 'professional-placement',
  OTHER: 'other'
};

export const PURPOSE_OF_STAY = [
  { label: 'Undergraduate', value: PURPOSE_OF_STAY_TYPES.UNDERGRADUATE },
  { label: 'Postgraduate', value: PURPOSE_OF_STAY_TYPES.POSTGRADUATE },
  { label: 'Summer school', value: PURPOSE_OF_STAY_TYPES.SUMMER_SCHOOL },
  { label: 'Internship', value: PURPOSE_OF_STAY_TYPES.INTERNSHIP },
  { label: 'Professional', value: PURPOSE_OF_STAY_TYPES.PROFESSIONAL_PLACEMENT },
  { label: 'Other', value: PURPOSE_OF_STAY_TYPES.OTHER }
];
